import { supabase, AuthUser } from '../lib/supabase';

export const authService = {
    // Login com email e senha
    async signIn(email: string, password: string): Promise<{ user: AuthUser | null; error: string | null }> {
        const { data, error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });

        if (error) {
            return { user: null, error: error.message };
        }

        return {
            user: data.user ? { id: data.user.id, email: data.user.email! } : null,
            error: null,
        };
    },

    // Cadastro com email e senha
    async signUp(email: string, password: string): Promise<{ user: AuthUser | null; error: string | null }> {
        const { data, error } = await supabase.auth.signUp({
            email,
            password,
        });

        if (error) {
            return { user: null, error: error.message };
        }

        return {
            user: data.user ? { id: data.user.id, email: data.user.email! } : null,
            error: null,
        };
    },

    // Logout
    async signOut(): Promise<{ error: string | null }> {
        const { error } = await supabase.auth.signOut();
        return { error: error?.message || null };
    },

    // Obter usuário atual
    async getCurrentUser(): Promise<AuthUser | null> {
        const { data: { user } } = await supabase.auth.getUser();
        return user ? { id: user.id, email: user.email! } : null;
    },

    // Listener para mudanças de autenticação
    onAuthStateChange(callback: (user: AuthUser | null) => void) {
        return supabase.auth.onAuthStateChange((event, session) => {
            const user = session?.user;
            callback(user ? { id: user.id, email: user.email! } : null);
        });
    },

    // Recuperar senha
    async resetPassword(email: string): Promise<{ error: string | null }> {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: `${window.location.origin}/reset-password`,
        });
        return { error: error?.message || null };
    },
};
